import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { Modules } from './components/Modules';
import { LookInside } from './components/LookInside';
import { BonusSection } from './components/BonusSection';
import { ChangeSection } from './components/ChangeSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & typeof globalThis & {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
};
const PIXEL_ID = '1037491992204255';
export function App() {
  useEffect(() => {
    const pixelWindow = window as PixelWindow;
    try {
      if (!pixelWindow.fbq) {
        const fbq = ((...args: unknown[]) => {
          if (fbq.callMethod) {
            fbq.callMethod(...args);
          } else {
            fbq.queue?.push(args);
          }
        }) as PixelFunction;
        pixelWindow.fbq = fbq;
        if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript?.parentNode) {
          firstScript.parentNode.insertBefore(script, firstScript);
        } else {
          document.head.appendChild(script);
        }
      }
      pixelWindow.fbq?.('init', PIXEL_ID);
      pixelWindow.fbq?.('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="d3cr1enu48a8">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="d3wbb20yj8rf" />
      </noscript>
      <div className="min-h-screen w-full overflow-x-hidden bg-white text-brand-carbon" data-id="element-2" data-mp="3gm647qcpav3v">
        <PurchasePopup data-id="element-3" data-mp="3bncnzq614q00" />
        <main data-id="element-4" data-mp="3bo4mb8r0h1tz">
          <Hero data-id="element-5" data-mp="3bk72ekwm0691" />
          <PainSection data-id="element-6" data-mp="3qb7jtffc3ahb" />
          <SystemSection data-id="element-7" data-mp="3qbfvx53mubrg" />
          <Modules data-id="element-8" data-mp="3qcr0360zplj3" />
          <LookInside data-id="element-9" data-mp="3qdaienujybxn" />
          <BonusSection data-id="element-10" data-mp="3lkhfm5in9do7" />
          <ChangeSection data-id="element-11" data-mp="3lk7lc5qkgkcp" />
          <PricingCard data-id="element-12" data-mp="3liwkadoi9qpa" />
          <Guarantee data-id="element-13" data-mp="3liehey7c8e8e" />
          <Testimonials data-id="element-14" data-mp="2xun1zlqi3l2w" />
          <FAQ data-id="element-15" data-mp="2xu3n6dw5dct3" />
          <FinalCTA data-id="element-16" data-mp="2xtlozbpxcoij" />
        </main>
        <Footer data-id="element-17" data-mp="2xsk46fj3wnnm" />
      </div>
    </>;
}